import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {CityService} from '../../shared/service/city.service';
import swal from 'sweetalert2';
import {ActionMode} from '../../shared/enums/action-mode.enum';
import {DistrictDTO} from '../../shared/dto/district.model';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup} from '@angular/forms';
import {CityDTO} from '../../shared/dto/city.model';
import {CityPopupComponent} from '../location-mgt/city/city-popup/city-popup.component';
import {DistrictService} from '../../shared/service/district.service';
import {InventoryModel} from '../../shared/dto/inventory.model';
import {AddNewComponent} from './add-new/add-new.component';
import {ApplicantRequestService} from '../../service/applicant-request.service';
import {ApprovalService} from '../../service/approval.service';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {EditInventryDetailsComponent} from './edit-inventry-details/edit-inventry-details.component';
import {InventoryService} from '../../service/inventory.service';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-inventory-details',
  templateUrl: './inventory-details.component.html',
  styleUrls: ['./inventory-details.component.scss']
})
export class InventoryDetailsComponent implements OnInit {

  public inventoryForm: FormGroup;
  public invModel: InventoryModel[] = [];
  public invConfigItem: InventoryModel[] = [];
  public href: string = '';
  invModelSer: InventoryModel = new InventoryModel();
  public historyModel: InventoryModel[];
  public inventoryDetails: any;

  displayedColumns: string[] = ['serial', 'sid', 'status', 'date', 'user', 'remark', 'action'];
  dataSource: MatTableDataSource<any>;

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;

  constructor(public modalService: NgbModal,
              private tokenStorageService: TokenStorageService,
              private router: Router,
              private applicantRequestService: ApplicantRequestService,
              private approvalService: ApprovalService,
              public inventory_service: InventoryService,
              private http: HttpClient) {
  }

  ngOnInit() {
    this.loadData();

    this.getLastInventoryDetails();
    this.getCardsCount();

    this.inventoryForm = new FormGroup({
      fDate: new FormControl(null),
      toDate: new FormControl(null),
      start: new FormControl(null),
      end: new FormControl(null),
    });
    this.href = this.router.url;
    // this.onLoadGetData();

    this.inventoryDetails = {
      OpeningQty: '00',
      TotalAddedQty: '00',
      TotalReturnedQty: '00',
      TotalIssuedQty: '00',
      TotalCancelQty: '00',
      AvailableStockQty: '00',
      ReOrderLevel: '00'
    }
  }


  onClickNew() {
    const modalRef = this.modalService.open(AddNewComponent, {
      windowClass: 'xlModal'
    });
    modalRef.componentInstance.invRecord = this.invConfigItem;
    this.approvalService.setModel(this.modalService)
    // modalRef.result.then((data: string) => {
    //   if (data == 'Saved') {
    //     // this.onLoadGetData();
    //     // this.loadCities();
    //     // this.loadDistricts();
    //   }
    // }, () => {
    //
    // });
  }

  onEditInventory() {
    const modalRef = this.modalService.open(EditInventryDetailsComponent, {
      windowClass: 'xlModal'
    });

    modalRef.result.finally(() => {
      console.log('Modal Results');
      this.getLastInventoryDetails();
    });
  }

  onClickReset() {
    this.inventoryForm.reset();
    this.loadData();
  }

  onSubmitSearch() {

    console.log(this.inventoryForm.value.fDate, 'this.inventoryForm.value.fDate');

    this.invModelSer.from = this.inventoryForm.value.start;
    this.invModelSer.to = this.inventoryForm.value.end;
    this.invModelSer.fromDate = new Date(this.inventoryForm.value.fDate + ' 23:59:59');
    this.invModelSer.toDate = new Date(this.inventoryForm.value.toDate + ' 00:00:00');

    this.applicantRequestService.searchInventoryByPara(this.invModelSer).subscribe(
      (result: any) => {
        this.historyModel = result;
        this.dataSource = new MatTableDataSource(this.historyModel);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  loadData() {
    this.applicantRequestService.searchInventory().subscribe(
      (result: any) => {
        this.historyModel = result;
        this.dataSource = new MatTableDataSource(this.historyModel);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  deleteRow(id) {
    // swal.fire({
    //   title: 'Are you sure, you want to cancel?',
    //   text: '',
    //   input: 'textarea',
    //   showCancelButton: true,
    //   confirmButtonText: 'Yes',
    //   preConfirm: function (remark) {
    //     return new Promise(function (resolve, reject) {
    //       // setTimeout(function() {
    //       if (remark.value != null && remark.value != '') {
    //         swal.resetValidationMessage();
    //         swal.enableButtons();
    //       } else {
    //         swal.showValidationMessage('Please Enter Cancellation Remark!');
    //       }
    //       // });
    //     });
    //   },
    //   allowOutsideClick: false
    // }).then((result) => {
    //
    //   if (result.value != null && result.value != '') {
    //     this.applicantRequestService.deleteInventory(id).subscribe(
    //       (success: string) => {
    //         this.loadData();
    //         swal.fire('Success', 'Card cancelled successfully', 'success');
    //       },
    //       (error) => {
    //         console.log(error);
    //         this.loadData();
    //         swal.fire('Error', 'Something Went Wrong!', 'error');
    //       }, () => {
    //         this.getCardsCount();
    //       });
    //   } else {
    //
    //     // swal.fire();
    //   }
    // }, reason => {
    //   this.getCardsCount();
    // });
    let cancellationRemark = '';

    swal.fire({
      title: 'Are you sure, you want to cancel?',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      confirmButtonText: 'Yes',
      showLoaderOnConfirm: true,
      cancelButtonText: 'Cancel',
      preConfirm: (remark) => {
        if (remark == '' || remark == null) {
          swal.showValidationMessage(`Please Enter Cancellation Remark!`);
          return false;
        } else {
          cancellationRemark = remark;
          return true;
        }
      },
      allowOutsideClick: () => !swal.isLoading()
    }).then((result) => {
      if (result.value === true) {
        this.applicantRequestService.deleteInventory(id, cancellationRemark).subscribe(
          (success: string) => {
            this.loadData();
            swal.fire('Success', 'Card cancelled successfully', 'success');
          },
          (error) => {
            this.loadData();
            swal.fire('Error', 'Something Went Wrong!', 'error');
          }, () => {
            this.getCardsCount();
          });
      }else{
        swal.fire('Warning!', 'Operation Cancelled!', 'warning');
      }
    }, reason => {
      this.getCardsCount();
    });
  }

  returnRow(id) {
    swal.fire({
      title: 'Are you sure, you want to Return this card?',
      text: '',
      showCancelButton: true,
      confirmButtonText: 'Yes'
    }).then((result) => {
        if (result.value) {
          this.applicantRequestService.returnInventory(id).subscribe(
            (success: string) => {
              this.loadData();
              this.getCardsCount();
              swal.fire('Success', 'Card returned successfully', 'success');
            },
            (error) => {
              console.log(error);
              this.loadData();
              swal.fire('Error', 'Error in Returning', 'error');
            }, () => {
              this.getCardsCount();
            });
        }
      }, reason => {
        this.getCardsCount();
      }
    );
  }

  getLastInventoryDetails() {
    this.inventory_service.getLastInventory().subscribe(
      (data: any) => {

        this.inventoryDetails = {
          OpeningQty: data.openingQty,
          TotalAddedQty: data.totalAddedQty,
          // TotalReturnedQty:data.totalReturnedQty,
          // TotalIssuedQty:data.totalIssuedQty,
          // TotalCancelQty:data.totalCancelQty,
          AvailableStockQty: data.availableStockQty,
          ReOrderLevel: data.reOrderLevel
        }

        var currentOpeningQty = this.inventoryDetails.OpeningQty - this.inventoryDetails.TotalAddedQty;
        var reOrderLevel = this.inventoryDetails.ReOrderLevel;

        if(currentOpeningQty <= reOrderLevel){
          this.sendReOrderAlertSMS();
        }

        this.getCardsCount();

      },
      (error) => {
        swal.fire('Error', 'Error in loading inventory details', 'error');
      });
  }

  sendReOrderAlertSMS(){
    this.inventory_service.sendReOrderAlertSMS().subscribe();
  }


  getCardsCount() {
    this.inventory_service.getCarCountByStatus().subscribe(
      (data: any) => {
        // console.log(data,"data");
        this.inventoryDetails.TotalReturnedQty = data.Returned;
        this.inventoryDetails.TotalIssuedQty = data.Issued;
        this.inventoryDetails.TotalCancelQty = data.Cancel;
      },
      (error) => {
        swal.fire('Error', 'Error in loading inventory details', 'error');
      });
  }

}
